import { Component, OnInit } from '@angular/core';
import { constant } from 'app/app.constants';
import { TabsServiceProviderEnum } from 'app/core/enums/tabs-service-provicer.enum';

@Component({
  selector: 'app-tabs-service-provider',
  templateUrl: './tabs-service-provider.component.html',
  styleUrls: ['./tabs-service-provider.component.scss']
})
export class TabsServiceProviderComponent implements OnInit {

  tabsServiceProvider = constant.SERVICE_PROVIDER.TABS_SERVICE_PROVIDER;
  activatedTab: TabsServiceProviderEnum = TabsServiceProviderEnum.Form;

  constructor() { }

  ngOnInit() {
  }
  onChangeTabs(selectedTab: TabsServiceProviderEnum) {
    this.activatedTab = selectedTab;
  }

  isActiveTabServiceProvider(tabsActive): boolean {
    return this.activatedTab === tabsActive;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/service-provider/components/tabs-service-provider/tabs-service-provider.component.ts